import React from 'react';
import { classes } from './Content.classes';
import { dataHooks } from '../../constants';
import { ContentProps } from './Content.types';
import { SidePanelContext } from '../../SidePanelAPI';
import { useOverlayScrollbar } from '../../../providers/useOverlayScrollbar/useOverlayScrollbar';

const Content = ({
  children,
  scrollElementRef,
  className,
  noPadding = false,
  stretchVertically = true,
}: ContentProps) => {
  const [OverlayScrollbarHostElement, OverlayScrollbarContentElement] =
    useOverlayScrollbar();
  return (
    <SidePanelContext.Consumer>
      {({ skin }) => (
        <OverlayScrollbarHostElement
          className={classes.root(
            { noPadding, stretchVertically, skin },
            className,
          )}
          data-hook={dataHooks.sidePanelContent}
        >
          <OverlayScrollbarContentElement ref={scrollElementRef}>
            {children}
          </OverlayScrollbarContentElement>
        </OverlayScrollbarHostElement>
      )}
    </SidePanelContext.Consumer>
  );
};

export { Content };
